<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple"
            v-preventReClick @click="handleDelete">
            删除
          </el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      

      
      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
                  @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="hisPatientId" label="患者ID">
        <template slot-scope="scope">
          {{ scope.row.hisPatientId??'-' }}
        </template>
      </el-table-column>
      <el-table-column v-if="userInfo.isAdmin" prop="name" label="患者姓名"></el-table-column>
      <el-table-column v-else prop="name" label="患者姓名">
        <template slot-scope="scope">
          {{ formatName(scope.row.name) }}
        </template>
      </el-table-column>
      <el-table-column prop="sexName" label="性别"></el-table-column>
      <el-table-column v-if="userInfo.isAdmin" prop="phone" label="联系电话">
        <template slot-scope="scope">
          {{ scope.row.phone??'-' }}
        </template>
      </el-table-column>
      <el-table-column v-else prop="phone" label="联系电话">
        <template slot-scope="scope">
          {{ formatPhone(scope.row.phone??'-') }}
        </template>
      </el-table-column>
      <el-table-column prop="birthday" label="出生日期">
        <template slot-scope="scope">
          {{ scope.row.birthday?parseTime(new Date(scope.row.birthday), "{y}-{m}-{d}"):'-' }}
        </template>
      </el-table-column>
      <el-table-column v-if="userInfo.isAdmin" prop="idcard" label="身份证号码" width="200">
        <template slot-scope="scope">
          {{ scope.row.idcard??'-' }}
        </template>
      </el-table-column>
      <el-table-column v-else prop="idcard" label="身份证号码" width="200">
        <template slot-scope="scope">
          {{ formatIdCard(scope.row.idcard??'-') }}
        </template>
      </el-table-column>
      <el-table-column prop="operation" fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
          <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
            @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
            @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
  

      <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="1300px"
        :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="name" label="患者姓名">
                <el-input :disabled="!editMode" placeholder="请输入患者姓名"
                  :value="(noFormat()||viewMode) ? form.name : formatName(form.name)"
                  @input="val => { if (editMode) form.name = val }"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="phone" label="联系电话">
                <el-input :disabled="!editMode" :value="(noFormat()||viewMode) ? form.phone : formatPhone(form.phone)"
                  @input="val => { if (editMode) form.phone = val }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="6">
              <el-form-item :label="this.route.menuName +'类型'" prop="sourceTypes">
                <el-select  :disabled="!editMode" v-model="form.sourceTypeName"  placeholder="请选择模块" @change="systemTypeChange" style="width: 100%;">
                  <el-option v-for="item in systemType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item prop="sex" label="患者性别">
                <el-radio-group :disabled="!editMode" v-model="form.sex">
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="idcard" label="身份证号码">
                <el-input :disabled="!editMode" :value="(noFormat()||viewMode) ? form.idcard : formatIdCard(form.idcard)"
                  @input="val => { if (editMode) form.idcard = val }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="birthday" label="出生日期">
                <el-date-picker :disabled="!editMode" v-model="form.birthday" type="date" placeholder="选择出生日期"
                  value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址">
                <el-input :disabled="!editMode" v-model="form.address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-button class="btn default" size="small" v-if="editMode" v-preventReClick
            @click="addDetail">新增明细</el-button>
          <el-table :data="form.details" border class="table" height="250" ref="childTable"
            stripe :header-cell-style="{ background: '#DDEBFF' }" style="margin-top: 10px">
            <el-table-column prop="no" label="住院号/病历号" width="120">
              <template slot-scope="scope">
                <el-input placeholder="请输入住院号/病历号" :disabled="!editMode" v-model="scope.row.no"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="deptName" label="就诊科室" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.deptName" :disabled="!editMode" filterable :filter-method="getDepts"
                  @change="deptChange(scope.row)" placeholder="请选择就诊科室" style="width: 100%">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="doctorName" label="医生" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.doctorName" :disabled="!editMode" filterable :filter-method="getUsers"
                  @change="userChange(scope.row)" placeholder="请选择医生">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="doctorDeptName" label="医生所属科室" width="120">
            </el-table-column>
            <el-table-column prop="inHospitalDate" label="入院日期" width="150">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.inHospitalDate" :disabled="!editMode" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="isOutPatient" label="门诊标志" width="100">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isOutPatient" :disabled="!editMode" active-color="#286AB4"
                  inactive-color="#D4D4D4" :active-value="1" :inactive-value="0" />
                <!-- <el-select v-model="scope.row.isOutPatient" clearable placeholder="门诊标志">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.id"></el-option>
                </el-select> -->
              </template>
            </el-table-column>
            <el-table-column prop="contactor" label="联系人" width="100">
              <template slot-scope="scope">
                <el-input placeholder="请输入联系人" :disabled="!editMode" v-model="scope.row.contactor"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="contactPhone" label="联系电话" width="120">
              <template slot-scope="scope">
                <el-input placeholder="请输入联系电话" :disabled="!editMode" v-model="scope.row.contactPhone"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                <el-input placeholder="请输入备注" :disabled="!editMode" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>

            <el-table-column v-if="editMode" fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" class="red" @click="DeleteDetail(scope)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <el-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确
            定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { GetPatients, GetPatientById, RemovePatient, SavePatient } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectTree from "@/components/select-tree";
import SelectFilter from "@/components/table-select-filter";
import { WhetherOptions, ProductionPlaceOptions } from "@/enum";

export default {
  mixins: [GetDataMixin],
  components: {
    SelectTree,
    SelectFilter,
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        // sourceType:'1',
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 查看模式
      viewMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        specName: [
          {
            required: true,
            message: "请选择规格型号",
            trigger: "blur",
          },
        ],
        productRegistCertName: [
          {
            required: true,
            message: "请选择产品注册证",
            trigger: "blur",
          },
        ],
        minUnit: [
          {
            required: true,
            message: "请输入最小单位",
            trigger: "blur",
          },
        ],
      },
      certRules: {
        productRegistCertId: [
          {
            required: true,
            message: "产品注册证不能为空",
            trigger: "blur",
          },
        ],
      },
      filterOptions: [
        {
          name: "患者ID",
          type: "input",
          code: "hisPatientId",
        },
        {
          name: "身份证号",
          type: "input",
          code: "idCard",
        },
        {
          name: "就诊科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDeptsBySessionDeptId,
          data: [],
        },
        {
          name: "病案号",
          type: "input",
          code: "patientNo",
        },
        {
          name: "患者姓名",
          type: "input",
          code: "name",
        },
      ],
      systemType: [
        {
          id: '1',
          name: "耗材",
        },
        {
          id: '2',
          name: "药品",
        },
      ],
      defaultProps: {
        children: "childs",
        label: "name",
      },
      WhetherOptions: WhetherOptions,
      ProductionPlaceOptions: ProductionPlaceOptions,
      certForm: {},
      openCertDialog: false,
    };
  },
  methods: {
    
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetPatients(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    handleInfo (row) {
      GetPatientById({
        id: row.id,
      }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.open = true;
        this.editMode = false;
        this.viewMode = true;
        // 普通用户加隐私保护
        if (!this.userInfo.isAdmin) {
          this.form = {
            ...this.form,
            name: this.formatName(this.form.name),
            phone: this.formatPhone(this.form.phone),
            idcard: this.formatIdCard(this.form.idcard)
          };
        }
      });
    },
    // 编辑
    handleUpdate (row) {
      GetPatientById({
        id: row.id,
      }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.open = true;
        this.title = "编辑";
        this.editMode = true;
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SavePatient(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally(() => {
            this.$store.dispatch('SetLoading', false)
          });
      });
    },
    resetForm () {
      this.form = {
        id: 0,
        no: "",
        deptName: "",
        deptId: "",
        name: "",
        phone: "",
        age: "",
        sex: 0,
        idcard: "",
        inHospitalDate: "",
        doctor: "",
        doctorDeptId: "",
        doctorDeptName: "",
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 取消编辑
    cancel () {
      this.$store.dispatch('SetLoading', false)
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemovePatient({
            ids,
          });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        sourceType: "1",
        orgCode :sessionStorage.getItem('orgId')
      };

      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },

    // detail
    addDetail () {
      this.form.details.push({});
    },
    DeleteDetail (e) {
      const index = e.$index;
      this.form.details.splice(index, 1);
    },

    deptChange (row) {
      row.deptId = row.deptName;
    },
    userChange (row) {
      let arr = this.STATIC_Users.filter((item) => item.id == row.doctorName);
      if (arr && arr.length > 0) {
        row.doctorName = arr[0].name;
        row.doctor = arr[0].id;
        row.doctorDeptId = arr[0].deptId;
        row.doctorDeptName = arr[0].deptName;
      }
    },

    // 隐私保护格式化方法
    formatName (name) {
      if (!name) return '';
      const length = name.length;
      if (length <= 1) return name;
      if (length === 2) return name[0] + '*';
      if (length === 3) return name[0] + '*' + name[2];
      return name[0] + '*'.repeat(length - 2) + name.slice(-1);
    },
    formatIdCard (idcard) {
      if (!idcard || idcard.length < 15) return idcard;
      return idcard.substring(0, 6) + '********' + idcard.substring(14);
    },
    formatPhone (phone) {
      if (!phone || phone.length !== 11) return phone;
      return phone.substring(0, 3) + '****' + phone.substring(7);
    },
    noFormat(){
      return (this.title=='编辑' || this.title=='新建')
    },
    tabClick () {
      this.getData();
    },
    systemTypeChange(val){
      this.form.sourceTypes= val.join(';')
    },
  },
  mounted () {
    this.getData();
    this.getUsers("");
    this.getDepts("");
  },
};
</script>

<style lang="scss" scoped></style>
